/**
 * ENG-2626 Phase B trim flags — hide sections per acceptance criteria.
 */
export const SHIPMENT_DETAIL_TRIM = {
  activityTab: true,
  visibilityMetrics: true,
  deviceSpeed: true,
  deviceTemperature: true,
  deviceHumidity: true,
  deviceStaleAlert: true,
  shipmentMode: true,
  assignedTeam: true,
  exceptionCardInteractive: true,
} as const;
